import PublisherActions from '../../../../actions/PublisherActions';
import RegionsActions from '../../../../actions/RegionsActions';
import AppConstants from '../../../../constants/AppConstants';
import store from '../../../../stores/redux';

export const actions = {
    getConversion(id) {
        let params = {
            ids: id
        };

        PublisherActions.getConversions(params, () => {
            actions.getRegions();
        }, {
            before: AppConstants.CONVERSION_SEARCH_START_LOADING,
            success: AppConstants.CONVERSION_SEARCH_ITEM_SUCCESS
        });
    },

    getRegions() {
        const state = store.getState();
        const track = state?.conversions?.item?.track;
        const request = track?.request;
        const regionID = request?.region;

        if (regionID) {
            RegionsActions.searchRegions({
                ids: regionID
            });
        }
    }
};
